// The block setting that says which menu a menu block shows.
//
// The theme stores it as `menu_id` and calls `linklists(section.settings.menu_id)`
// with it, so the stored value stays the menu's own id ("header"). Only the
// editor changes: an id typed by hand is something you either remember or get
// wrong, and "Menu ID" names the storage rather than the choice being made.
const MENU_KEYS = ["menu_id", "menu", "menu_slug"];

export function isMenuField(section) {
  if (!section) {
    return false;
  }
  return section.type === "menu" || MENU_KEYS.includes(section.key);
}

// What the field is called on screen. Everything else keeps the name the
// theme gave it.
export function fieldLabel(section) {
  return isMenuField(section) ? "Menu" : section?.name;
}
